import { render } from "./complaint-page.vue?vue&type=template&id=f6f15040"
import script from "./complaint-page.vue?vue&type=script&lang=js"
export * from "./complaint-page.vue?vue&type=script&lang=js"

import "./complaint-page.vue?vue&type=style&index=0&id=f6f15040&lang=scss"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__